import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { AddressDB } from '../../../user-management/models/address'
import { SetEnrollmentDataPdf } from '../../models/set-enrollment-data-pdf'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'ExternalAgentStep5',
    templateUrl: 'external-agent-step5.html',
    styleUrls: ['external-agent.component.scss']
})
export class ExternalAgentStep5 implements OnInit {
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    enrollmentSameAddress: EnrollmentViewModel = {} as EnrollmentViewModel
    residentialAddress: AddressDB = {} as AddressDB
    mailingAddress: AddressDB = {} as AddressDB
    confirmationNumber: string
    showUpdatesSettingsMessage = 'Success'
    setPdf: SetEnrollmentDataPdf = {} as SetEnrollmentDataPdf
    PlanTypeName: string
    selectedPlanYear: number

    constructor(private router: Router, private _enrollementGateway: EnrollmentGateway, public _global: PortalGlobals) {
        this.enrollment = {} as EnrollmentViewModel
        this.setPdf = {} as SetEnrollmentDataPdf
    }

    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        sessionStorage.setItem('enrollmentViewModel', JSON.stringify(this.enrollment))
        localStorage.setItem('enrollmentViewModel', JSON.stringify(this.enrollment))

        if (this.enrollment !== undefined && this.enrollment.CONF !== undefined) {
            this.confirmationNumber = this.enrollment.CONF
        }
        if (this.enrollment.ISSINGLEGROUP === true) {
            this.PlanTypeName = this.enrollment.PLANTYPENAME

            this.enrollment.PLANTYPENAME = this.enrollment.PLANTYPE
        }
        if (this.enrollment !== undefined) {
            this.SendEmailOnConfirmation(this.enrollment.PLANTYPENAME)
        }

        //Remove session object for enrollment cache
        if (sessionStorage.getItem('EnrollmentCache') != null) {
            sessionStorage.removeItem('EnrollmentCache')
        }
    }

    enrollNewAddress(): void {
        let isSingleGroup = false
        isSingleGroup = this.enrollment.ISSINGLEGROUP
        this.enrollment = {} as EnrollmentViewModel
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (isSingleGroup) this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step1/1'])
        else this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step1'])
    }

    enrollSameAddress(): void {
        let isSingleGroup = false
        this.enrollmentSameAddress = {} as EnrollmentViewModel
        this.enrollmentSameAddress.residentialAddress = this.enrollment.residentialAddress
        this.enrollmentSameAddress.mailingAddress = this.enrollment.mailingAddress

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        isSingleGroup = this.enrollment.ISSINGLEGROUP
        if (isSingleGroup) {
            this.enrollmentSameAddress.ISSINGLEGROUP = isSingleGroup
            this.enrollmentSameAddress.AGENTNAME = this.enrollment.AGENTNAME
            // this.enrollmentSameAddress.SINGLEGRPNAME = this.enrollment.SINGLEGRPNAME
            this.enrollmentSameAddress.STCOBGROUPNAME = this.enrollment.SINGLEGRPNAME
            this.enrollmentSameAddress.PLANTYPENAME = this.PlanTypeName
            this.enrollmentSameAddress.PLANTYPE = this.enrollment.PLANTYPE

            this.enrollmentSameAddress.SAMEADDRESS = true
            this.enrollmentSameAddress.ISSTCOB = this.enrollment.ISSTCOB

            this.enrollmentSameAddress.STCOBGROUPNAME = this.enrollment.STCOBGROUPNAME
            this.enrollmentSameAddress.CARRIER = this.enrollment.CARRIER
            this.enrollmentSameAddress.ACCOUNT = this.enrollment.ACCOUNT
            this.enrollmentSameAddress.GROUP = this.enrollment.GROUP
            this.enrollmentSameAddress.CUID = this.enrollment.CUID
            this.enrollmentSameAddress.CHANNELID = this.enrollment.CHANNELID

            this.enrollmentSameAddress.SINGLEGRPNAME =
                this.enrollment.STCOBGROUPNAME + '-' + this.enrollment.CARRIER + '-' + this.enrollment.ACCOUNT + '-' + this.enrollment.GROUP
        }

        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentSameAddress)
        if (isSingleGroup) {
            this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step1/1'])
        } else this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step1/SameAddress'])
    }
    SendEmailOnConfirmation(planname: string): void {
        this._enrollementGateway.SendEmailOnConfirmation(planname).subscribe(() => (this.showUpdatesSettingsMessage = 'Success'))
    }

    SavePdf(): void {
        //if (this.enrollment.EOB !== undefined) {
        //    if (this.enrollment.EOB.toString().toUpperCase() === 'EEOB') {
        //        this.enrollment.EOB = 'Yes'
        //    } else {
        //        this.enrollment.EOB = 'No'
        //    }
        //}
        //else {
        //    this.enrollment.EOB = ''
        //}
        //if (this.enrollment.EOB !== undefined) {
        //    if (this.enrollment.EOB === '3') {
        //        this.enrollment.EOB = 'Yes'
        //    } else {
        //        this.enrollment.EOB = 'No'
        //    }
        //}
        //else {
        //    this.enrollment.EOB = ''
        //}
        if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== null)
            this.selectedPlanYear = this._global.selectedPlanYear
        else this.selectedPlanYear = 2021
       
        this._enrollementGateway
            .generatePDF(this.enrollment, this._global.currentUser.insuranceCompanyName, this.selectedPlanYear)
            .subscribe((model: any) => {
                var binaryString = window.atob(model)
                var binaryLen = binaryString.length
                if (binaryLen == 3) {
                    console.log('File doesnt exist / some back ground  error')
                    // this.downloadError = 'File Not Found'
                    return
                }
                //  this.downloadError = ''
                var bytes = new Uint8Array(binaryLen)
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i)
                    bytes[i] = ascii
                }

                let fileName = this.enrollment.APPLN + '-' + this.enrollment.APPFN + '.pdf'
                // below code needed for ie browser
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    ;(window.navigator as any).msSaveBlob(new Blob([bytes], { type: 'application/pdf' }), fileName)
                }
                // for other browsers
                var fileURL = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }))
                // window.open(fileURL)
                var link = document.createElement('a')
                link.setAttribute('href', fileURL)
                link.setAttribute('download', fileName)
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
    }
}
